/**
 * Handles all functionality related to the primary navigation container
 */

import ClassNames from "./classNames.js";
import DomElements from "./domElements.js";
const { $menuButtonMobile, $navContainerWrapper } = DomElements;
import Overlay from "./handleOverlay.js";
const { reevaluateOverlay } = Overlay;
import { interpretAction } from "../../@helpers/js/interpretAction.js";

/**
 * On click menu button (small vp)
 */
const initMenuButton = () => {
  $menuButtonMobile?.addEventListener("click", () => {
    if (!isOpen()) {
      toggleNavigation("open");
    } else toggleNavigation("close");
    reevaluateOverlay();
  });
};

/**
 * Check if open
 *
 * @returns 'true' if open, 'false' if hidden
 */
const isOpen = () => !!$navContainerWrapper?.classList?.contains(
  `${ClassNames.layout.navContainerWrapper}--${ClassNames.modifiers.active}`
);

/**
 * Toggle visibility
 *
 * @param action Type of action to handle
 */
function toggleNavigation(action) {
  $menuButtonMobile.classList[interpretAction(action)](
    `${ClassNames.layout.menuButtonMobile}--${ClassNames.modifiers.active}`
  );
  $menuButtonMobile.setAttribute(
    "aria-expanded",
    `${!($menuButtonMobile.getAttribute("aria-expanded") === "true")}`
  );

  $navContainerWrapper.classList[interpretAction(action)](
    `${ClassNames.layout.navContainerWrapper}--${ClassNames.modifiers.active}`
  );
}

export default {
  initMenuButton,
  isOpen,
  toggleNavigation,
};
